import React from 'react';
import PropTypes from 'prop-types';
import UploadButton from './UploadButton';
import EmailPromptModal from '../../../common/EmailPromptModal';

const ImportSubscriptionsForm = ({ onChange, onSubmit, emailIsOn, defaultEmail }) => (
  <div className="c-memberships-container u-full-width">
    <form>
      <div className="c-memberships-container__text c-memberships-container__title u-text-left">
        Import members from .csv
      </div>
      <div className="c-memberships-container__text u-text-left">
        <p className="u-mb+">Upload your .csv file that contain the email of the members
          and their associated membership package. Please note that
          the memberships will need to be <strong>exact match</strong> as
          the memberships created on Squire.</p>

        The header of the .csv file must contain:
        <ul>
          <li>Email address</li>
          <li>Membership package name</li>
        </ul>
      </div>
      <div className="u-mt+">
        <UploadButton onChange={onChange}>Upload .csv file</UploadButton>
      </div>
    </form>

    <EmailPromptModal
      display-if={emailIsOn}
      onSubmit={onSubmit}
      title="Email to receive results"
      defaultEmail={defaultEmail}
    />
  </div>
);

ImportSubscriptionsForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  emailIsOn: PropTypes.bool,
  defaultEmail: PropTypes.string,
};

ImportSubscriptionsForm.defaultProps = {
  emailIsOn: false,
  defaultEmail: '',
};

export default ImportSubscriptionsForm;
